// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input-disabled[data-v-db3062a0] input {\n  background: transparent !important;\n}\n", ""]);
// Exports
module.exports = exports;
